<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="{ name: 'Config' }" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.Create_Enum") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ENUM_Name')"
              >
                <vs-input
                  :label="$t('system.label.ENUM_Name')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="enumName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ENUM_Id')"
              >
                <vs-input
                  :label="$t('system.label.ENUM_Id')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="enumId"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ENUM_Property')"
              >
                <vs-input
                  :label="$t('system.label.ENUM_Property')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="enumMessageProperty"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.ENUM_Value')"
              >
                <vs-input
                  :label="$t('system.label.ENUM_Value')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="enumValue"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createbroadcaster"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "/config" },
        { name: "Create Enum", to: "/" },
      ],
      enumName: "",
      enumId: "",
      enumMessageProperty: "",
      enumValue: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {},
  methods: {
    async createbroadcaster() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        enumName: this.enumName,
        enumId: this.enumId,
        enumMessageProperty: this.enumMessageProperty,
        enumValue: this.enumValue,
      };
      await this.$store.dispatch("configuration/createEnumAction", payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "ENUM Created Successfully!",
        type: "success",
      });
      this.$router.push({ name: "Config" });
    },
    cancel() {
      this.$router.push({ name: "Config" });
    },
    resetForm() {
      this.hardwareUomList.Name = "";
      this.hardwareUomList.Description = "";
    },
  },
  watch: {},
  mounted() {
    this.resetForm();
  },
};
</script>
